import { render, staticRenderFns } from "./active-customer-handler.vue?vue&type=template&id=43e86b1a"
import script from "./active-customer-handler.vue?vue&type=script&lang=js"
export * from "./active-customer-handler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports